import {markNoticeDismissedForPage} from '@github-ui/copilot-chat-helpers/copilot-onboarding'
import {dismissUserNoticePath} from '@github-ui/paths'
import {reactFetch} from '@github-ui/verified-fetch'
import {announce} from '@github-ui/aria-live'

export async function dismissNotice(noticeName: string): Promise<void> {
  markNoticeDismissedForPage(noticeName)
  try {
    const response = await reactFetch(dismissUserNoticePath({noticeName}), {method: 'POST', keepalive: true})
    if (!response.ok) throw new Error(`Unable to dismiss notice ${noticeName}: ${response.status}`)
  } catch {
    announce('Could not save your dismissal.')
  }
}
